<template>
  <div class="main-father">
    <div class="main-body">
      <el-tabs v-model="editableTabsValue" type="card" @tab-remove="removetabs">
        <el-tab-pane
          v-for="(item, index) in menuTabs"
          :key="index"
          :label="item.title"
          :name="item.name"
          :closable="item.name != '/welcome'"
        >
          <el-card :style="`height:${scroll_height}px`">
            <el-scrollbar
              wrapStyle="overflow-x:hidden;"
              :style="`height:${scroll_height}px`"
            >
              <keep-alive
                :include="keepAliveUrl"
                :exclude="noKeepAlive"
                class="main-father"
              >
                <router-view
                  v-if="item.name == editableTabsValue"
                ></router-view>
              </keep-alive>
            </el-scrollbar>
          </el-card>
          <!--  -->

          <!-- <router-link to="/Mycard"> 123</router-link>
           -->
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      /* 标签页 */
      noKeepAlive: "/welcome",
      scroll_height: ""
    };
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 110;
        } else {
          this.scroll_height = newinner.innerHeight - 130;
        }
        this.SETMAINh(this.scroll_height);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    },
    editableTabsValue: {
      get() {
        return this.$store.state.home.editableTabsValue;
      },
      set(val) {
        // 页面刷新时val是0，不要触发跳转
        this.$router.push(val);
        this.UPDATEMENUTABS(val);
      }
    },
    ...mapGetters("home", ["keepAliveUrl"]),
    menuTabs: {
      get() {
        return this.$store.state.home.menuTabs;
      },
      set(val) {
        return (this.$store.state.home.menuTabs = val);
      }
    }
  },
  created() {
    //开始跳转到指定路由
    this.$router.push(this.editableTabsValue);
  },
  methods: {
    ...mapMutations("home", ["REMOVETABS", "UPDATEMENUTABS"]),
    ...mapMutations("resolution", ["SETMAINh"]),
    removetabs(targetName) {
      this.REMOVETABS(targetName);
    }

    // 动态更新keep-alive的incloud
    /* keepAliveUrl() {
      var result = this.menuTabs.map(item => {
        return item.name.slice(1);
      });
      return result.join(",");
    } */
  }
};
</script>
<style lang="less" scoped>
.main-father {
  position: relative;
  width: 100%;
  height: 100%;
  /* background-color: purple; */
  /* padding: 10px; */
  /* background-color: rgb(233, 233, 233); */
  padding: 5px;
}
.main-body {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 10px 5px 5px 5px;
}
.el-card {
  padding: 0px;
  margin: 0px;
}
/deep/.el-card__body {
  padding: 0 !important;
}
</style>
